import { UntypedFormGroup } from '@angular/forms';

/**
 * Class used for checking if passwords match
 */
export class PasswordMatcherValidator {
  /**
   * Checks if the controlName and matchingControlName have equal value.
   */
  static matches(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      // Return if another validator has already found an error
      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      // Set error on matchingControl if validation fails
      matchingControl.setErrors(control.value !== matchingControl.value ? { mustMatch: true } : null);
    };
  }
}
